import React, { useEffect, useState } from "react";
import "../portfolio.css";
import UnauthorizedNavbar from "./unauthorizedNavbar";
import UnauthorizedFooter from "./unauthorizedFooter";
import { FaGooglePlay, FaApple } from "react-icons/fa";

const StockIdeas = () => {
  const [faqs, setFaqs] = useState([]);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [stocks, setStocks] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [showPopup, setShowPopup] = useState(false);


    useEffect(() => {
      fetch(`${BASE_URL}/activeStockRecommendation`)
        .then((res) => res.json())
        .then((data) => {
          let all = data?.data || [];   

          setStocks(all);
        });
    }, []);

  useEffect(() => {
    // fetch(`${BASE_URL}/fetchActiveQueAns`)
    fetch(`${BASE_URL}/fetchActiveQueAns`)
      .then((res) => res.json())
      .then((response) => {
        if (response?.data) {
          const homepageFaqs = response.data.filter(
            (item) => item.section === "stockideas"
          );
  
          setFaqs(homepageFaqs);
        }
      })
      .catch((err) => console.error("FAQ Fetch Error:", err));
  }, []);

    const cardContent = [
      {
        title: "Turnaround Play",
        logo: "Turnaround_Play.jpg",
        part1: `
          <b>The Thesis: Opportunity in Adversity</b><br/><br/>
          Markets are emotional and often over-punish good companies facing temporary headwinds. <br>
          <b>Turnaround Play</b>  is our high-conviction swing category built to find these dislocations. 
          We don’t buy “falling knives”; we wait for the inflection point where a beaten-down stock stabilizes, shifts structure, and starts moving upward. 
          The aim is to capture the sharp relief rally and the structural re-rating that follows.
        `,
        part2: `
          <b>Our “No-Randomness” Framework</b><br/>
          Every stock must clear a strict multi-stage filter.<br/><br/>

          <b>Stable Entry:</b> Technical confirmation of the “check-mark” reversal using our framework.<br/>
          <b>Market Sentiment:</b> We study sector and breadth shifts to validate trade probability.<br/><br/>

          <b>The Swing Trading Advantage</b><br/>
          Turnaround setups often deliver the fastest swings as moves from oversold to neutral are sharp.<br/><br/>

          • Entry: You get an alert the moment a stock qualifies.<br/>
          • Exit: We track momentum and notify you when it moves outside our framework.
        `
      },

      {
        title: "Momentum Breakouts",
        logo: "Momentum_BreakOut.jpg",
        part1: `
          <b>The Thesis: Follow the Flow of Capital</b><br/><br/>
          Markets reward strength. <br/>
          <b>Momentum Breakouts</b> rely on the proven idea that stocks showing superior price performance 
          often continue upward.<br/>
          We don’t look for bargains — we look for force.  
          The goal is to enter high-velocity stocks during their breakout phase and ride the surge created by institutional demand.
        `,
        part2: `
          <b>Our “No-Randomness” Framework</b><br/>
          Every stock must pass a strict multi-stage benchmark.<br/><br/>

          <b>Relative Strength:</b> We compare each candidate to the Nifty 50 and select those displaying clear outperformance.<br/>
          <b>Technical Trigger:</b> We mark key resistance zones and act only when the breakout is decisive and validated.<br/><br/>

          <b>The Swing Trading Advantage</b><br/>
          Momentum Breakouts offer the most time-efficient swings. High velocity means faster moves toward targets and lower opportunity cost.<br/><br/>

          • Entry: You receive an alert the moment a stock qualifies.<br/>
          • Exit: We track momentum and notify you when it moves outside our framework.
        `
      },

      {
        title: "High Growth Stocks",
        logo: "High_Growth_Stocks.jpg",
        part1: `
          <b>The Thesis: Earnings Drive Price</b><br/><br/>
          Sentiment moves markets in the short term, but earnings drive them in the long term.<br/>
          <b>High Growth Stocks</b> focuses on companies entering their “Golden Phase”—periods of strong revenue expansion, rising margins, and growing market share. 
          But we don’t simply buy and hold. We use swing-trading principles to enter these leaders at optimal technical levels, capturing the price surges that accompany their growth cycle.
        `,
        part2: `
          <b>Our “No-Randomness” Framework</b><br/>
          Every stock must meet strict Techno-Fundamental criteria.<br/><br/>

          <b>Business Performance:</b> Consistent growth, strong ROE, improving margins, and manageable debt.<br/>
          <b>Sector Leadership:</b> We prioritize companies gaining market share within expanding sectors.<br/>
          <b>Technical Entry:</b> Even a great business is a bad trade at the wrong price. We act only when momentum and structure align, giving you a growth leader at a value entry.<br/><br/>

          <b>The Swing Trading Advantage</b><br/>
          High-growth businesses offer a natural safety net. Strong fundamentals often cushion volatility compared to speculative trades.<br/><br/>

          • Entry: You receive an alert when a new stock qualifies.<br/>
          • Exit: We track price and fundamentals, notifying you if the trend breaks.
        `
      },

      {
        title: "Value Stocks",
        logo: "Value_Stocks.jpg",
        part1: `
          <b>The Thesis: The Arbitrage of Mispricing</b><br/><br/>
          Markets are not always efficient. Fear, noise, and liquidity shocks can push strong companies far below their true worth.<br/>
          <b>Value Stocks</b> aims to exploit this mispricing.
          We identify the Margin of Safety—the gap between market price and intrinsic value—and use swing trading principles to capture the upward correction as the market re-rates the stock.
        `,
        part2: `
          <b>Our “No-Randomness” Framework</b><br/>
          Every stock must clear a disciplined valuation and quality benchmark.<br/><br/>

          <b>Valuation Modeling:</b> We estimate fair value using structured frameworks—DCF OR PE, etc<br/>
          <b>Fundamental Strength:</b> We select only healthy balance-sheet businesses; weak fundamentals are rejected regardless of how cheap the stock appears.<br/><br/>

          <b>The Swing Trading Advantage</b><br/>
          Value swing trades provide a psychological edge. Buying near intrinsic support reduces downside risk and allows for more confident position sizing.<br/><br/>

          • Entry: You receive an alert when a stock enters the Value Zone and confirms technical support.<br/>
          • Exit: We notify you once it reaches the Fair Value Zone or loses momentum, allowing efficient capital rotation.
        `
      }
    ];

    const toggleFaq = (index) => {
      setOpenIndex(openIndex === index ? null : index);
    };

  const handleSubscribe = (store) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      if (store === "android") {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.bossinvestor.app";
      } else if (store === "ios") {
        window.location.href =
          "https://apps.apple.com/us/app/example-app/id123456789"; // replace with real ID
      }
    } else {
      setShowPopup(true);
    }
  };



  return (
    <>
      <UnauthorizedNavbar />

      <div className="mp-wrapper" style={{background: 'linear-gradient(to bottom right, #f1e8f7, #fdf4e7'}}>

        <header className="header-section">
          <h1 className="header-title">
            Start Trading with  <br className="hide-md" />
            <span className="text-brand-gradient">Professional Research</span>
          </h1>
          <p className="header-subtitle">
            Access high-conviction Swing Trading Ideas curated by SEBI-registered Research Analysts—all four stock ideas included in one subscription.
          </p>
        </header>

        <section className="cards-section">
          {stocks.map((item, index) => {
            return (
              <div
                key={index}
                className="portfolio-page-card"
                style={{ animationDelay: `${0.3 + index * 0.2}s` }}
              >
                <div className="top-strip"></div>

                <div className="card-body">
                  <div className="card-header">
                    <div className="card-header-left">
                      <div className="icon-box purple">
                        <img 
                          src={item.iconURL}
                          alt={item.title}
                          className="portfolio-icon"
                        />
                      </div>
                      <div>
                        <h3 className="card-title">{item.title} {"-"} {item.description}</h3>
                        <div className="badge-row">
                          <span className="badge purple-badge rounded-full">
                            
                          </span>

                          <span className="badge orange-badge rounded-full">
                            
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="portfolio-card-desc">
                    
                  </p>
                  <div 
                    dangerouslySetInnerHTML={{ __html: cardContent[index].part1 }}
                  ></div>

                <div className="stats-box"
                  dangerouslySetInnerHTML={{ __html: cardContent[index].part2 }}
                >
                </div>
                </div>
              </div>
            );
          })}

        </section>

        <section className="download-section">
          <div className="blur-circle top-right"></div>
          <div className="blur-circle bottom-left"></div>
          <div className="download-container">
            <h2 className="download-title">
              Your Pocket Research Analyst<br />
              <span className="highlight">Download BossInvestor</span>
            </h2>
            <p className="download-text">
              Unlock exclusive Swing Trading Opportunities, get instant notifications for Entry & Exit points.  
            </p>
            <div className="download-buttons">
              <a
                className="download-btn"
                onClick={() => handleSubscribe("android")}
              >
                <FaGooglePlay className="icon" />
                Google Play
              </a>

              <a
                className="download-btn"
                onClick={() => handleSubscribe("ios")}
              >
                <FaApple className="icon" />
                App Store
              </a>
            </div>
          </div>
        </section>

        <section className="portfolio-faq-section" style={{paddingTop : '50px', marginBottom:'0px !important',background: 'linear-gradient(to bottom right, #f1e8f7, #fdf4e7'}}>
          <div className="container">
            <h2 className="faq-title">Frequently Asked Questions</h2>
              <div className="faq-list">
                {faqs.map((faq, index) => (
                  <div key={faq.id} className="faq-item">
                    <button
                      className="faq-question"
                      onClick={() => toggleFaq(index)}
                    >
                      <span>{faq.question}</span>
                      <svg
                        className={`faq-icon ${openIndex === index ? "open" : ""}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        ></path>
                      </svg>
                    </button>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                ))}
              </div>
          </div>
        </section>
      </div>
      {showPopup && (
        <div className="qr-overlay" onClick={() => setShowPopup(false)}>
          
          <div className="qr-modal" onClick={(e) => e.stopPropagation()}>

            <button className="qr-close-icon" onClick={() => setShowPopup(false)}>
              ✕
            </button>

            <h2 className="qr-title">Get the Bossinvestor App</h2>
            <img 
              src="/playstoreScanner.jpeg" 
              alt="QR Code" 
              style={{ width: "170px", height: "170px", borderRadius: "12px" }}
            />
            <p className="qr-subtitle">
              Scan the QR code to download the app
            </p>

          </div>
        </div>
      )}

      <UnauthorizedFooter />
    </>
  );
};

export default StockIdeas;
